import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Label from "../../components/label";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function ContactPage() {
  return (
    <div className="p-0">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = usePageProvider();

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
      {({ values, setFieldValue }) => (
        <Form>
          <Accordion defaultActiveKey="0" className="my-4">
            {/* SEO SECTION */}
            <Accordion.Item eventKey="0" className="w-full">
              <Accordion.Header>SEO META</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  <div className="flex flex-col">
                    <Label label="Meta Title" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_title" placeholder="Meta Title" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col">
                    <Label label="Meta Keywords" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_keyword" placeholder="Meta Keywords" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col">
                    <Label label="Meta Slug Url" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_slug_url" placeholder="Meta SLug Url" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col col-span-3">
                    <Label label="Meta Description" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_desc" placeholder="Meta Description" rootClassName="w-full" as="textarea" />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* BANNER SECTION */}
            <Accordion.Item eventKey="1" className="w-full">
              <Accordion.Header>Banner Section</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <div>
                      <Label label="Banner Heading" className="mb-1 " />
                      <FormikInput name="banner.heading" placeholder="Banner Heading" />
                    </div>
                    <div>
                      <Label label="Sub Heading / Description" className="mb-1 " />
                      <FormikTextarea name="banner.sub_heading" placeholder="Sub Heading" className="!h-24" />
                    </div>
                  </div>
                  <div>
                    <Label label="Banner Background Image" className="mb-1 " />
                    <ImageUploader
                      imageUrl={values.banner?.image}
                      onChange={(res) => setFieldValue("banner.image", res?.data?.file_url)}
                      imgStyle={{ width: "100%", height: "180px" }}
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* CONTACT INFO */}
            <Accordion.Item eventKey="2" className="w-full">
              <Accordion.Header>Contact Info Section</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8 pb-6 border-b border-gray-100">
                  <div>
                    <Label label="Section Main Heading" className="mb-1 " />
                    <FormikInput name="contact_info.heading" placeholder="Section Heading" />
                  </div>
                  <div>
                    <Label label="Section Description" className="mb-1 " />
                    <FormikTextarea name="contact_info.description" placeholder="Description" className="!h-20" />
                  </div>
                </div>

                <Label label="Managed Contact Channels" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                <FieldArray name="contact_info.details">
                  {(arrayHelpers) => (
                    <div className="overflow-x-auto">
                      <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                        <thead className="bg-gray-50 border-b">
                          <tr>
                            <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-32">Type</th>
                            <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-40">Label</th>
                            <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Value (Info)</th>
                            <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-24">Icon</th>
                            <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y">
                          {values.contact_info?.details?.map((detail, index) => (
                            <tr key={index} className="hover:bg-gray-50/50 transition-colors">
                              <td className="p-2 border-r align-middle">
                                <FormikInput name={`contact_info.details.${index}.type`} placeholder="e.g. phone" className="text-sm" />
                              </td>
                              <td className="p-2 border-r align-middle">
                                <FormikInput name={`contact_info.details.${index}.label`} placeholder="Call Us" className="text-sm" />
                              </td>
                              <td className="p-2 border-r align-middle">
                                <FormikInput name={`contact_info.details.${index}.value`} placeholder="+91..." className="text-sm" />
                              </td>
                              <td className="p-2 border-r align-middle">
                                <ImageUploader
                                  imgStyle={{ width: "40px", height: "40px" }}
                                  imageUrl={detail.logo_img}
                                  onChange={(res) => setFieldValue(`contact_info.details.${index}.logo_img`, res?.data?.file_url)}
                                />
                              </td>
                              <td className="p-2 text-center align-middle">
                                <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600">
                                  <FontAwesomeIcon icon={faTrash} size="sm" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="mt-4">
                        <Button type="button" variant="outline" className="!py-2 !px-4 !text-[12px]" onClick={() => arrayHelpers.push({ type: "address", label: "", value: "", logo_img: "" })}>
                          + Add New Contact Channel
                        </Button>
                      </div>
                    </div>
                  )}
                </FieldArray>
              </Accordion.Body>
            </Accordion.Item>

            {/* FORM CONFIG */}
            <Accordion.Item eventKey="3" className="w-full">
              <Accordion.Header>Inquiry Form Configuration</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8 pb-6 border-b border-gray-100">
                  <div>
                    <Label label="Form Heading" className="mb-1 " />
                    <FormikInput name="form.heading" placeholder="Form Heading" />
                  </div>
                  <div>
                    <Label label="Submit Button Label" className="mb-1 " />
                    <FormikInput name="form.button_text" placeholder="Submit Button Text" />
                  </div>
                </div>

                <Label label="Defined Form Fields" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                <FieldArray name="form.fields">
                  {(arrayHelpers) => (
                    <div className="overflow-x-auto">
                      <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                        <thead className="bg-gray-100 border-b">
                          <tr>
                            <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Internal Name</th>
                            <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Display Placeholder</th>
                            <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-40">Input Type</th>
                            <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y">
                          {values.form?.fields?.map((field, index) => (
                            <tr key={index} className="hover:bg-gray-50/50">
                              <td className="p-2 border-r">
                                <FormikInput name={`form.fields.${index}.name`} placeholder="e.g. first_name" className="text-sm font-semibold" />
                              </td>
                              <td className="p-2 border-r">
                                <FormikInput name={`form.fields.${index}.placeholder`} placeholder="Enter Name..." className="text-sm" />
                              </td>
                              <td className="p-2 border-r">
                                <FormikInput name={`form.fields.${index}.type`} placeholder="text / email / textarea" className="text-sm" />
                              </td>
                              <td className="p-2 text-center">
                                <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600">
                                  <FontAwesomeIcon icon={faTrash} size="sm" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="mt-4">
                        <Button type="button" variant="outline" className="!py-2 !px-4 !text-[12px]" onClick={() => arrayHelpers.push({ name: "", placeholder: "", type: "text" })}>
                          + Add New Field
                        </Button>
                      </div>
                    </div>
                  )}
                </FieldArray>
              </Accordion.Body>
            </Accordion.Item>

            {/* MAP SETTINGS */}
            <Accordion.Item eventKey="4" className="w-full">
              <Accordion.Header>Global Map Integration</Accordion.Header>
              <Accordion.Body>
                <div className="space-y-4">
                  <div>
                    <Label label="Google Maps Embed URL" className="mb-1 " />
                    <FormikInput name="map.url" placeholder="Paste iframe src URL here..." />
                  </div>
                  {values.map?.url ? (
                    <div className="mt-4 rounded-2xl overflow-hidden border-4 border-gray-50 shadow-inner group relative">
                      <iframe src={values.map.url} className="w-full h-[350px] border-0" title="Map Preview" />
                      <div className="absolute top-2 left-2 bg-black/50 text-white text-[10px] px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">Live Preview</div>
                    </div>
                  ) : (
                    <div className="mt-4 h-[200px] bg-gray-50 border-2 border-dashed border-gray-200 rounded-2xl flex flex-col items-center justify-center text-gray-400">
                      <p className="text-sm italic">No map URL provided.</p>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5" className="w-full">
              <Accordion.Header>{"Footer Banner Image"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 mb-6">
                  <Label label="Footer Banner Image" className="mb-1" />
                  <ImageUploader className="text-xs" imgStyle={{ fontSize: "12px" }}
                    title="Footer Banner Image"
                    imageUrl={values.footer_bgimg}
                    onChange={(res) => setFieldValue("footer_bgimg", res?.data?.file_url)}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {/* FIXED BOTTOM SAVE BAR */}
          <div className="save-button-bar !bg-white/95 !backdrop-blur-md">
            <Button type="submit" label="SAVE CHANGES" />
          </div>
        </Form>
      )}
    </Formik>
  );
}
